export const environment = {
    production: true,
    baseHref: '/SierraCountyPublic',
    apiBase: 'https://mydashgis.com/SierraCountyPublic',
    debug: true,
};
